import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { RemunerationStatementInfoCollection } from '../../../Models/Models/Reports/RemunerationStatementInfoCollection';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class RemunerationStatementHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(network: string, company: string, fromDate: IJsonDate, toDate: IJsonDate, start: number, pageSize: number, useGenericFileName: boolean): Promise<RemunerationStatementInfoCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Mi/RemunerationStatementHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { network: network, company: company, fromDate: fromDate, toDate: toDate, start: start, pageSize: pageSize, useGenericFileName: useGenericFileName }

    return AjaxWrapper.get<RemunerationStatementInfoCollection, any>(url, data);
  }
}

